import script from "./communityWritePage.vue?vue&type=script&setup=true&lang=js"
export * from "./communityWritePage.vue?vue&type=script&setup=true&lang=js"

import "./communityWritePage.vue?vue&type=style&index=0&id=4295d7cf&lang=css"

const __exports__ = script;

export default __exports__